import React, { Component } from 'react';
import { connect } from 'react-redux';

import Spinner from '../../components/generics/Spinner';
import { printAll, printLabel} from '../../utils/PrintHelper';
import ProductionLabelList from '../../components/sessions/ProductionLabelList';
import _ from 'lodash';
import queryString from 'query-string';

import { fetchSessionOutput, fetchSessionOutputSuccess, fetchSessionOutputFailure } from "../../store/sessions/actions";
import { withRouter } from "utils/WithRouter";

export class ProductionLabelsContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      newLabels: [],
      printedLabels: [],
      intermediateLabels: false,
      finishSession: false,
    };
  }

  componentDidMount() {
    this.props.fetchSessionOutput(this.props.match.params.id);

  }

  componentDidUpdate(prevProps) {
    if(prevProps.sessionOutput.loading && !this.props.sessionOutput.loading){
      const params = queryString.parse(this.props.location.search);
      const finishSession = params.finish_session ? params.finish_session : false;
      const intermediateLabels = params.intermediate_labels ? params.intermediate_labels : false;
      let newLabels = [];
      let printedLabels = [];

      // Labels when finishSession
      if (finishSession) {
        newLabels = _.filter(this.props.sessionOutput.output.results, (item) => {
          return !item.intermediate_label;
        });
        printedLabels = _.differenceWith(this.props.sessionOutput.output.results, newLabels, _.isEqual);

      // Labels to print when creating new intermediateLabels
      } else if (intermediateLabels) {
        newLabels = this.props.sessionIntermediateLabels ? this.props.sessionIntermediateLabels.newLabels : [];
        printedLabels = _.differenceWith(this.props.sessionOutput.output.results, newLabels, _.isEqual);

      // Show all labels for finished session
      } else {
        newLabels = this.props.sessionOutput.output.results;
      }

      this.setState({ newLabels, printedLabels, intermediateLabels, finishSession });
    }
  }

  goBack = () => {
    this.props.history.push(`/session/${this.props.match.params.id}/edit`);
  };

  render() {
    if (this.props.sessionIntermediateLabels.loading || this.props.sessionOutput.loading){
      return <Spinner />
    }
    let styleFrame= { height: '0px', width: '0px', position: 'absolute' };
    return (
      <div>

        { this.state.intermediateLabels ?
        <div className="d-flex justify-content-end pb-1">
          <span onClick={()=>{this.goBack()}} className="btn btn-success m-0 mr-05"> Back to Session <i className="fa fa-arrow-left"></i></span>
        </div>
        : null }

        {this.state.newLabels.length > 0 ?
          <ProductionLabelList
            title={this.state.intermediateLabels || this.state.finishSession ? 'New Labels' : 'Label List'}
            sessionOutput={this.state.newLabels}
            sessionId={this.props.match.params.id}
            printLabel={printLabel}
            printAll={printAll}
            emptyTableMsg={'No labels to Print'}/>
        : null}

        {this.state.printedLabels.length > 0 ?
          <ProductionLabelList
            title={'Already Printed'}
            printListMessage={'Print Again'}
            sessionOutput={this.state.printedLabels}
            sessionId={this.props.match.params.id}
            printLabel={printLabel}
            printAll={printAll}
            intermediateLabels={true}
            emptyTableMsg={'No labels to Print'}/>
          : null }

        {this.state.newLabels.length === 0 && this.state.printedLabels.length === 0 ?
          <div className="empty-table-message">
            <span> No labels to Print </span>
          </div>
        :null }

        <iframe title={`ifmcontentstoprint`} id={`ifmcontentstoprint`} style={styleFrame}></iframe>

      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    sessionIntermediateLabels: state.sessions.sessionIntermediateLabels,
    sessionOutput: state.sessions.sessionOutput,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSessionOutput: (iId) => {
      dispatch(fetchSessionOutput(iId)).payload.then((response) => {
        dispatch(fetchSessionOutputSuccess(response.data))
      }, (error) => {
        dispatch(fetchSessionOutputFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductionLabelsContainer));
